import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const uploadStateToCloud = createAsyncThunk('data-store/storeState', async (param) => {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE}/save-design`, param);
    return response.data;
});

const initialState = {
    upload: 'idle',
    id: ''
};

const storeStateSlice = createSlice({
    name: 'data-store',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(uploadStateToCloud.pending, (state) => {
            state.upload = 'uploading';
        });
        builder.addCase(uploadStateToCloud.fulfilled, (state, action) => {
            state.upload = 'fulfilled';
            state.id = action.payload.id;
        });
    }
});

const storeStateReducer = storeStateSlice.reducer;
export default storeStateReducer;
